module.exports = __webpack_public_path__ + "gi.svg?9f13139786b951ae0fd128acfcbe2dbd";